import { type TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import AlignedFieldsRadioGroup, {
  type Signature as AlignedFieldsRadioGroupSig
} from '../aligned-fields-radio-group.gts';
import ValidatedField from '../validated-field.gts';
import RadioProvider, {
  type S as RadioProviderSig
} from './basic-radio-group/radio-provider.gts';

interface Signature {
  Element: HTMLDivElement;
  Args: Pick<
    AlignedFieldsRadioGroupSig['Args'],
    'displaySubText' | 'subText' | 'title' | 'isMandatory'
  > &
    Pick<
      RadioProviderSig['Args'],
      | 'changeset'
      | 'propertyName'
      | 'isReadOnly'
      | 'disabled'
      | 'translationKey'
    > & {
      errorClass?: string;
    };
  Blocks: {
    default: [RadioProviderSig['Blocks']['default'][0]];
  };
}

const ChangesetAlignedFieldsRadioGroup: TOC<Signature> = <template>
  <ValidatedField
    @propertyName={{@propertyName}}
    @changeset={{@changeset}}
    @errorClass={{or @errorClass 'error-validated-input-display'}}
  >
    <AlignedFieldsRadioGroup
      @title={{@title}}
      @propertyName={{@propertyName}}
      @isMandatory={{@isMandatory}}
      @displaySubText={{@displaySubText}}
      @subText={{@subText}}
      ...attributes
    >
      {{!
        The radio provided by the BasicRadioGroup are not using the changeset
        so we have to provide the right ones by using this specific radio provider.
      }}
      <RadioProvider
        @translationKey={{@translationKey}}
        @changeset={{@changeset}}
        @propertyName={{@propertyName}}
        @isReadOnly={{@isReadOnly}}
        @disabled={{@disabled}}
        as |provider|
      >
        {{yield provider}}
      </RadioProvider>
    </AlignedFieldsRadioGroup>
  </ValidatedField>
</template>;

export default ChangesetAlignedFieldsRadioGroup;
